import axios, { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'react';
import {
    FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_FAILURE,
    FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_REQUEST,
    FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_SUCCESS,
    FETCH_LOCKER_WISE_VENDOR_APPOINTMENTS_SUCCESS,
    GET_LOCKERS_COUNT,
} from '../constants/lockerWiseAvailability.constants';
import {
    FetchLockerWiseAvailabilityAndAppointmentsAction,
    LockerWiseAvailabilityAndAppointmentsResponse,
    vendorAppointmentsResponse,
} from '../interfaces/lockerWiseAvailability.interface';

const fetchLockerWiseAvailabilityAndAppointmentsRequest = () => {
    return {
        type: FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_REQUEST,
    };
};

const fetchLockerWiseAvailabilityAndAppointmentsSuccess = (data: LockerWiseAvailabilityAndAppointmentsResponse) => {
    return {
        type: FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_SUCCESS,
        payload: data,
    };
};

const fetchLockerWiseAvailabilityAndAppointmentsFailure = (errorMsg: string) => {
    return {
        type: FETCH_LOCKER_WISE_AVAILABILITY_AND_APPOINTMENTS_FAILURE,
        payload: errorMsg,
    };
};

const getLockersCount = (lockerCounts: number) => {
    return {
        type: GET_LOCKERS_COUNT,
        payload: lockerCounts,
    };
};

const fetchLockerVendorAppointments = (vendorAppointments: vendorAppointmentsResponse) => {
    return {
        type: FETCH_LOCKER_WISE_VENDOR_APPOINTMENTS_SUCCESS,
        payload: vendorAppointments,
    };
};

export const fetchLockerWiseAvailabilityAndAppointments = (locationId: string) => {
    return async (dispatch: Dispatch<FetchLockerWiseAvailabilityAndAppointmentsAction | any>) => {
        dispatch(fetchLockerWiseAvailabilityAndAppointmentsRequest());
        return await axios
            .get(`/admin/availabilities/location/${locationId}`)
            .then((response: AxiosResponse) => {
                if (response.data.statusCode === 200) {
                    dispatch(fetchLockerWiseAvailabilityAndAppointmentsSuccess(response.data.availability));
                    dispatch(getLockersCount(response.data.lockersCount));
                    dispatch(fetchLockerVendorAppointments(response.data.vendorAppointments))
                }
            })
            .catch((error: AxiosError) => dispatch(fetchLockerWiseAvailabilityAndAppointmentsFailure(error.message)));
    };
};
